// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"149":"cae0ea27","213":"ee721a80","568":"008742c1","649":"ade91372"}[chunkId] + ".chunk.js";
};